const routes = {
  home: "/",
  lobby: "/lobby",
  game: "/game",
  videoTest: "/videoTest",
  spectate: "/spectate"
};

export default routes;
